import React from 'react'

export const configContextValue = {
  recaptchaKey: '6Lf4ldoqAAAAAAyUPVtyjh4cl07fuTKdXRYqfEyz',
  googleMapUrl:
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyCtcl3kuRqdQSzxnvqloIyI-t4zZm_jupU&v=3.exp&libraries=geometry,places',
}

const ConfigContext = React.createContext(configContextValue)

export default ConfigContext
